module.exports = __webpack_public_path__ + "static/grafika2-28c6d2ee43d39b0b5933178e694cbec1.png";